import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserStatService } from '../../statistics/user-stat.service';
import { Observable, Subscription } from 'rxjs';
import { ParametersService } from '../../services/parameters.service';

@Component({
  selector: 'app-user-stat',
  templateUrl: './user-stat.component.html',
  styleUrls: ['./user-stat.component.css']
})
export class UserStatComponent implements OnInit, OnDestroy {
  usersStats : any = {};
  loading = true;
  subscription : Subscription;

  constructor(private userStatService : UserStatService,
              private paramService : ParametersService) { }

  ngOnInit() {
    this.reloadData();

    this.subscription = Observable.interval(this.paramService.dashboardRefreshInterval).subscribe(() => this.reloadData());
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  reloadData() : void {
    this.userStatService.getUserStats().subscribe(data => {
      this.usersStats = data;
      this.loading = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/user-stat/user-stat.component.ts